import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Об этой игре" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
      Это русская версия игры на угадывание слов {' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="underline font-bold"
        >
          Wordle
        </a>{' '}
      Если вы хотите посетитеподдерживать меня посетите {''}
        <a
          href="https://www.patreon.com/techpluscraft"
          className="underline font-bold"
        >
          Patreon
        </a>
      </p>
    </BaseModal>
  )
}
